import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { IconText } from "@ui/components/info/IconText";
import { StatusIndicator } from "@ui/components/status";
import { SButton } from "@ui/components/buttons/SButton";
import { useTranslation } from "react-i18next";
import { between } from "@ui/components/style/style";
import AlarmTypeIcon from "@ui/components/icons/AlarmTypeIcon";
import CodeIcon from "@ui/components/icons/CodeIcon";
export const AlarmCard = ({ row, canAcknowledge, onAcknowledge, onViewDetails, onEdit, }) => {
    var _a;
    const { t } = useTranslation(["common"]);
    const isAcknowledged = row.handlingStatus === "acknowledged";
    return (React.createElement(MobileCard, null,
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { gap: 1 }) },
            React.createElement(Box, { sx: { minWidth: 0 } },
                React.createElement(Typography, { variant: "subtitle2" }, row.location),
                React.createElement(Typography, { variant: "body2", color: "text.secondary" }, ((_a = row.handledBy) === null || _a === void 0 ? void 0 : _a.trim()) || "-")),
            React.createElement(StatusIndicator, { variant: row.handlingStatus })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:calendar-linear", text: row.date })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:clock-circle-linear", text: row.time }))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 } },
                    React.createElement(AlarmTypeIcon, { size: 24, color: "#637381" }),
                    React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true, sx: { minWidth: 0 } }, row.alarmType))),
            React.createElement(Grid, { size: 6 },
                React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 } },
                    React.createElement(CodeIcon, { size: 24, color: "#637381" }),
                    React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true, sx: { minWidth: 0 } }, `${row.value} / 22`)))),
        row.explanation && (React.createElement(Typography, { variant: "body1", color: "text.primary" }, `${t("common:grid.explanation")} : ${row.explanation}`)),
        isAcknowledged && canAcknowledge ? (React.createElement(SButton, { variant: "outlined", size: "small", fullWidth: true, onClick: () => onEdit(row.id) }, t("common:actions.viewEdit"))) : !isAcknowledged && canAcknowledge ? (React.createElement(SButton, { variant: "outlined", size: "small", fullWidth: true, onClick: () => onAcknowledge(row.id) }, t("common:actions.acknowledge"))) : null));
};
